<section class="bg-white dark:bg-gray-800 h-full w-full">
  <div class="py-8 px-4 mx-auto max-w-screen-md text-center lg:py-16 lg:px-12 flex flex-col justify-center items-center h-full">
    <h1 class="mb-4 text-4xl font-bold tracking-tight leading-none text-black dark:text-white-900 lg:mb-6 md:text-5xl xl:text-6xl">În mentenanță.</h1>
    <p class="text-black dark:text-white-900 md:text-lg xl:text-xl">Aplicația este în curs de actualizare.</p>
  </div>
</section>
